import { FC } from 'react';

import {
  TabsTabProps as MantineTabsTabProps,
  Tabs as MantineTabs
} from '@mantine/core';

import { Badge } from '../../datadisplay';

interface TabProps extends MantineTabsTabProps {
  badgeCount?: number;
  fullHeight?: boolean;
}

const Tab: FC<TabProps> = ({
  badgeCount,
  children,
  rightSection,
  color,
  ...rest
}) => {
  return (
    <MantineTabs.Tab
      {...rest}
      color={color}
      rightSection={
        badgeCount ? (
          <Badge
            variant="filled"
            size="sm"
            radius="sm"
            color={color}
            fz={9}
            h={14}
            fw={600}
            px={4}
          >
            {badgeCount}
          </Badge>
        ) : rightSection ? (
          rightSection
        ) : undefined
      }
    >
      {children}
    </MantineTabs.Tab>
  );
};

export { Tab };
export type { TabProps };
